export type PriceType = {
    initial: number;
    subsidized?: number;
    forever: number;
    foreverWithoutBig?: number;
    final: number;
    duration?: number;
    promoLabel?: string;
    type?: PRICE_TYPE;
};

export enum PRICE_TYPE {
    TODAY = 'IMMEDIAT',
    MONTHLY = 'MENSUEL',
    DEFERRED = 'DIFFERE',
    OTHER = 'AUTRE',
}
